import { render, staticRenderFns } from "./ServerErrorPage.vue?vue&type=template&id=3590842b&scoped=true&"
import script from "./ServerErrorPage.vue?vue&type=script&lang=js&"
export * from "./ServerErrorPage.vue?vue&type=script&lang=js&"
import style0 from "./ServerErrorPage.vue?vue&type=style&index=0&id=3590842b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3590842b",
  null
  
)

export default component.exports